import React, { Component } from "react";
import { MasonryInfiniteGrid } from "@egjs/react-infinitegrid";
import { ShowCenterSpinner } from "./statelessView";

class FiniteGridLayout extends Component {
  render() {
    const { children, loaded } = this.props;

    return (
      <MasonryInfiniteGrid
        className="gridlayout gridlayout-container"
        loading={<ShowCenterSpinner loaded={loaded} />}
        container={false}
        useFit
        useRecycle
        horizontal={false}
        isConstantSize
        isEqualSize
        align="center"
        gap={15}
      >
        {children}
      </MasonryInfiniteGrid>
    );
  }
}

FiniteGridLayout.propTypes = {};

export default FiniteGridLayout;
